import React from 'react'
import TableRow from './TableRow'

const MemberTableBody = ({item}) => {
    const {SNo, Plan, MaxBranch, MaxMember, Amount, Type, RegDate, StartDate,ExpireDate,Remarks,Status} = item;
    return (
        <>
        
            <tr className="tableborder">
                <TableRow
                    tableTitle={SNo}
                />
                <TableRow
                    tableTitle={Plan}
                />
                <TableRow
                    tableTitle={MaxBranch}
                />
                <TableRow
                    tableTitle={MaxMember}
                />
                <TableRow
                    tableTitle={Amount}
                />
                <TableRow
                    tableTitle={Type}
                />
                <TableRow
                    tableTitle={RegDate}
                />
                <TableRow
                    tableTitle={StartDate}
                />
                <TableRow
                    tableTitle={ExpireDate}
                />
                <TableRow
                    tableTitle={Remarks}
                />
                <TableRow
                    tableTitle={Status}
                />
            </tr>
       
        </>
    )
}

export default MemberTableBody
